/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarynext2Inputs */

const en_medialibrarynext2 = /** @type {(inputs: Medialibrarynext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next asset`)
};

const de_medialibrarynext2 = /** @type {(inputs: Medialibrarynext2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächster Inhalt`)
};

/**
* | output |
* | --- |
* | "Next asset" |
*
* @param {Medialibrarynext2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarynext2 = /** @type {((inputs?: Medialibrarynext2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarynext2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarynext2(inputs)
	return de_medialibrarynext2(inputs)
});
export { medialibrarynext2 as "mediaLibraryNext" }